<template>
	<div class="applications">
		<div class="loading-wrap" v-if="isLoading">
			<img :src="loadingGif" />
		</div>
		<Nav subNav="工具箱" :isShowBack="1"></Nav>
		<div class="device-tabs">
			<div class="list-wrap">
				<div class="list-wrap-hr"></div>
				<div
					class="arrow-left arrow"
					@click="arrowLeftClick"
					v-if="list.length > 4"
				></div>
				<div
					class="arrow-right arrow"
					@click="arrowRightClick"
					v-if="list.length > 4"
				></div>
				<div
					:class="{ list: true, nopadding: list.length < 5 }"
					id="list"
				>
					<div
						v-for="(item, index) in list"
						v-bind:key="item.peerid"
						class="item"
						:class="currentClickClass(index)"
						@click="tabsClick(index, item.peerid, item)"
					>
						<div :class="activeClass(index)">
							<div class="bgBlack"></div>
						</div>
						<div class="device-bind-wrap">
							<div class="device-status-wrap">
								<div
									:class="{
										'device-icon': true,
										'device-icon-pc':
											item.pidInfo.cid == 99,
										'device-icon-router':
											item.pidInfo.cid == 134,
										'device-icon-off':
											item.term.status == 1,
									}"
								>
									<div
										:class="{
											'device-status': true,
											'device-status-off':
												item.term.status == 1,
										}"
									>
										<div v-if="item.term.status == 1">
											离线
										</div>
										<div v-else>在线</div>
									</div>
								</div>
							</div>
							<div class="device-name-wrap">
								<div class="device-name">
									{{
										item.term.comment
											? item.term.comment
											: item.term.name
											? item.term.name
											: item.peerid
									}}
								</div>
								<div class="device-ip">
									IP：{{
										item.ip
											? $common.ipConvert(item.ip)
											: ""
									}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="wrap" @click="arrowDownClick">
			<div class="icon-wrap">
				<el-carousel trigger="click" height="115px" arrow="never">
					<el-carousel-item v-for="item in navItems" :key="item">
						<div :class="['item_wrap_' + item]">
							<div class="text1" v-if="item == 1">小宝驿站</div>
							<div class="text2" v-if="item == 1">
								开一间小宝驿站，乐享积分收益。
							</div>
							<div class="text1" v-if="item == 2">宽带提速</div>
							<div class="text2" v-if="item == 2">
								玩辰提速支持中国电信、中国联通一键物理宽带提速、最高可提至700M
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>

			<div class="app-wrap app-wrap3">
				<div class="text-icon"></div>
				<div class="text1">相册备份</div>
				<div class="text2">精彩瞬间 一键导出</div>
				<div
					:class="{
						btn: true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					@click="installXcbfClick"
					v-if="xcbf == -1"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "开启"
					}}
				</div>

				<div class="btn2" v-if="xcbf == 6">
					<div class="text">正在开启...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="xcbfPercent"
						color="#BDDBFF"
					></el-progress>
				</div>

				<div
					:class="{
						'btn3 btn-open': true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					v-if="xcbf == 1"
					@click="openXcbfClick"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "打开"
					}}
				</div>

				<div
					:class="{ 'btn3 btn-stop': true }"
					v-if="xcbf == 1 && !peerItem.term.status"
					@click="arrowXcbfClick"
				>
					已开启
					<div
						:class="{ icon: true, icon2: isShowXcbfUninstall }"
						@click.stop="arrowXcbfClick"
						v-if="!peerItem.term.status"
					></div>
				</div>
				<div
					class="uninstall-btn"
					v-if="isShowXcbfUninstall"
					@click="uninstallXcbfClick"
				>
					停止
				</div>
				<div class="btn2" v-if="xcbf == 9">
					<div class="text">正在停止...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="xcbfPercent"
						color="#BDDBFF"
					></el-progress>
				</div>
			</div>

			<div class="app-wrap app-wrap5">
				<div class="text-icon"></div>
				<div class="text1">视频备份</div>
				<div class="text2">美好时光 一键导出</div>
				<div
					:class="{
						btn: true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					@click="installSpbfClick"
					v-if="spbf == -1"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "开启"
					}}
				</div>

				<div class="btn2" v-if="spbf == 6">
					<div class="text">正在开启...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="spbfPercent"
						color="#BDDBFF"
					></el-progress>
				</div>

				<div
					:class="{
						'btn3 btn-open': true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					v-if="spbf == 1"
					@click="openSpbfClick"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "打开"
					}}
				</div>

				<div
					:class="{ 'btn3 btn-stop': true }"
					v-if="spbf == 1 && !peerItem.term.status"
					@click="arrowSpbfClick"
				>
					已开启
					<div
						:class="{ icon: true, icon2: isShowSpbfUninstall }"
						@click.stop="arrowSpbfClick"
						v-if="!peerItem.term.status"
					></div>
				</div>
				<div
					class="uninstall-btn"
					v-if="isShowSpbfUninstall"
					@click="uninstallSpbfClick"
				>
					停止
				</div>
				<div class="btn2" v-if="spbf == 9">
					<div class="text">正在停止...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="spbfPercent"
						color="#BDDBFF"
					></el-progress>
				</div>
			</div>

			<!-- 联系x1不支持小宝驿站 cid=123 现在还有x1 -->
			<div class="app-wrap app-wrap1" v-if="pidInfo.cid != 123">
				<div class="text1">小宝驿站</div>
				<div class="text2">开一间小宝驿站，乐享积分收益。</div>
				<div
					:class="{
						btn: true,
						'offline-btn': true,
					}"
					v-if="pidInfo.cid == 99"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "不支持开启"
					}}
				</div>
				<template v-else>
					<div
						:class="{
							btn: true,
							'offline-btn':
								peerItem.term.status &&
								peerItem.term.status == 1,
						}"
						@click="installXbjfClick"
						v-if="xbjf == -1"
					>
						{{
							peerItem.term.status && peerItem.term.status == 1
								? "设备离线"
								: "开启"
						}}
					</div>
					<div class="btn2" v-if="xbjf == 6">
						<div class="text">正在开启...</div>
						<el-progress
							:text-inside="true"
							:stroke-width="31"
							:percentage="xbjfPercent"
							color="#BDDBFF"
						></el-progress>
					</div>

					<div
						:class="{
							'btn3 btn-open': true,
							'offline-btn':
								peerItem.term.status &&
								peerItem.term.status == 1,
						}"
						v-if="xbjf == 1"
						@click.stop="openXbjfClick"
					>
						{{
							peerItem.term.status && peerItem.term.status == 1
								? "设备离线"
								: "打开"
						}}
					</div>

					<div
						:class="{ 'btn3 btn-stop': true }"
						v-if="xbjf == 1 && !peerItem.term.status"
						@click.stop="arrowXbjfClick"
					>
						已开启
						<div
							:class="{ icon: true, icon2: isShowXbjfUninstall }"
							@click.stop="arrowXbjfClick"
							v-if="!peerItem.term.status"
						></div>
					</div>
					<div
						class="uninstall-btn"
						v-if="isShowXbjfUninstall"
						@click="uninstallXbjsClick"
					>
						停止
					</div>
					<div class="btn2" v-if="xbjf == 9">
						<div class="text">正在停止...</div>
						<el-progress
							:text-inside="true"
							:stroke-width="31"
							:percentage="xbjfPercent"
							color="#BDDBFF"
						></el-progress>
					</div>
				</template>
			</div>
			<div class="app-wrap app-wrap2">
				<div class="text1">宽带提速</div>
				<div class="text2">
					玩辰提速支持中国电信、中国联通一键物理宽带提速、最高可提至700M
				</div>
				<div
					:class="{
						btn: true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					@click="installKdtsClick"
					v-if="kdts == -1"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "开启"
					}}
				</div>
				<div class="btn2" v-if="kdts == 6">
					<div class="text">正在开启...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="kdtsPercent"
						color="#BDDBFF"
					></el-progress>
				</div>

				<div
					:class="{
						'btn3 btn-open': true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					v-if="kdts == 1"
					@click="openKdtsClick"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "打开"
					}}
				</div>

				<div
					:class="{ 'btn3 btn-stop': true }"
					v-if="kdts == 1 && !peerItem.term.status"
					@click="arrowKdtsClick"
				>
					已开启
					<div
						:class="{ icon: true, icon2: isShowKdtsUninstall }"
						@click.stop="arrowKdtsClick"
						v-if="!peerItem.term.status"
					></div>
				</div>
				<div
					class="uninstall-btn"
					v-if="isShowKdtsUninstall"
					@click="uninstallKdtsClick"
				>
					停止
				</div>
				<div class="btn2" v-if="kdts == 9">
					<div class="text">正在停止...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="kdtsPercent"
						color="#BDDBFF"
					></el-progress>
				</div>
			</div>
			<div class="app-wrap app-wrap4">
				<div class="text1">远程开机</div>
				<div class="text2">Window主机 一键远程唤醒</div>
				<div
					:class="{
						'btn3 btn-open': true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					@click="openYckjClick"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "打开"
					}}
				</div>
				<!-- <div
					:class="{
						btn: true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					@click="installKdtsClick"
					v-if="kdts == -1"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "开启"
					}}
				</div>
				<div class="btn2" v-if="kdts == 6">
					<div class="text">正在开启...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="kdtsPercent"
						color="#BDDBFF"
					></el-progress>
				</div>

				<div
					:class="{
						'btn3 btn-open': true,
						'offline-btn':
							peerItem.term.status && peerItem.term.status == 1,
					}"
					v-if="kdts == 1"
					@click="openKdtsClick"
				>
					{{
						peerItem.term.status && peerItem.term.status == 1
							? "设备离线"
							: "打开"
					}}
				</div>

				<div
					:class="{ 'btn3 btn-stop': true }"
					v-if="kdts == 1 && !peerItem.term.status"
					@click="arrowKdtsClick"
				>
					已开启
					<div
						:class="{ icon: true, icon2: isShowKdtsUninstall }"
						@click.stop="arrowKdtsClick"
						v-if="!peerItem.term.status"
					></div>
				</div>
				<div
					class="uninstall-btn"
					v-if="isShowKdtsUninstall"
					@click="uninstallKdtsClick"
				>
					停止
				</div>
				<div class="btn2" v-if="kdts == 9">
					<div class="text">正在停止...</div>
					<el-progress
						:text-inside="true"
						:stroke-width="31"
						:percentage="kdtsPercent"
						color="#BDDBFF"
					></el-progress>
				</div> -->
			</div>
		</div>
		<Tip v-if="tip" :tip="tip"></Tip>
	</div>
</template>
<script>
import { mapActions } from "vuex";
import Nav from "@/components/Common/Nav.vue";
import Tip from "@/components/Tip.vue";

export default {
	name: "applications",
	components: {
		Nav,
		Tip,
	},
	data: function () {
		return {
			navItems: [1, 2],
			tip: "",
			loadingGif: require("../assets/home/node/loading.gif"),
			isLoading: false,
			kdtsPercent: 0,
			xbjfPercent: 0,
			xcbfPercent: 0,
			spbfPercent: 0,
			cur_pid: this.$route.params.cur_pid
				? this.$route.params.cur_pid
				: "",
			pidInfo: {
				cid: 0,
				did: 0,
			},
			isNoBind: false,
			currentTab: 0,
			list: [], //设备列表
			peerid: "",
			peerItem: {
				term: {},
			},
			isShowKdtsUninstall: false,
			isShowXbjfUninstall: false,
			isShowXcbfUninstall: false,
			isShowSpbfUninstall: false,
			kdts: 1, //已安装1 未安装-1安装又卸载了0 正在安装6	正在卸载9
			xbjf: 1, //已安装1 未安装-1安装又卸载了0
			xcbf: 1, //已安装1 未安装-1安装又卸载了0
			spbf: 1, //已安装1 未安装-1安装又卸载了0
		};
	},
	methods: {
		...mapActions([
			"bindget",
			"readguideget",
			"readguideset",
			"points",
			"deviceInfo",
			"limitget",
			"limitset",
			"cacheclean",
			"sendUserlog",
			"userGrowthInfo",
			"miniappList",
			"miniappStatus",
			"miniappAgree",
		]),

		arrowDownClick: function () {
			let _that = this;
			if (_that.isShowXbjfUninstall) {
				_that.isShowXbjfUninstall = false;
			}
			if (_that.isShowKdtsUninstall) {
				_that.isShowKdtsUninstall = false;
			}
			if (_that.isShowXcbfUninstall) {
				_that.isShowXcbfUninstall = false;
			}
			if (_that.isShowSpbfUninstall) {
				_that.isShowSpbfUninstall = false;
			}
		},

		installSpbfClick: function () {
			let _that = this;

			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}

			_that.spbf = 6;
			_that.spbfPercent = 5;
			setTimeout(function () {
				_that.spbfPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.spbfPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.spbfPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.spbf = 1;
			}, 2800);
			setTimeout(function () {
				_that.openSpbfClick();
			}, 3000);

			_that.miniappStatus([
				_that.peerid,
				"spbf",
				1,
				function (err, data) {},
			]);
		},
		openSpbfClick: function () {
			let _that = this;
			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}

			let dev_name = _that.peerItem.term.comment
				? _that.peerItem.term.comment
				: _that.peerItem.term.name
				? _that.peerItem.term.name
				: _that.peerItem.peerid;
			let dev_ip = _that.peerItem.ip
				? _that.$common.ipConvert(_that.peerItem.ip)
				: "";
			_that.$router.push({
				name: "VideoBackup",
				params: {
					cur_pid: _that.peerid,
					dev_name: dev_name,
					dev_ip: dev_ip,
					dtype: _that.peerItem.dtype,
				},
			});
		},
		arrowSpbfClick: function () {
			let _that = this;
			_that.isShowSpbfUninstall = !_that.isShowSpbfUninstall;
			_that.isShowXbjfUninstall = false;
			_that.isShowKdtsUninstall = false;
			_that.isShowXcbfUninstall = false;
		},
		uninstallSpbfClick: function () {
			let _that = this;
			_that.spbf = 9;
			_that.isShowSpbfUninstall = false;
			_that.miniappStatus([
				_that.peerid,
				"spbf",
				0,
				function (err, data) {},
			]);

			_that.spbfPercent = 5;
			setTimeout(function () {
				_that.spbfPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.spbfPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.spbfPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.spbf = -1;
			}, 2800);
		},

		installXcbfClick: function () {
			let _that = this;

			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}

			_that.xcbf = 6;
			_that.xcbfPercent = 5;
			setTimeout(function () {
				_that.xcbfPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.xcbfPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.xcbfPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.xcbf = 1;
			}, 2800);
			setTimeout(function () {
				_that.openXcbfClick();
			}, 3000);

			_that.miniappStatus([
				_that.peerid,
				"xcbf",
				1,
				function (err, data) {},
			]);
		},
		openXcbfClick: function () {
			let _that = this;
			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}

			let dev_name = _that.peerItem.term.comment
				? _that.peerItem.term.comment
				: _that.peerItem.term.name
				? _that.peerItem.term.name
				: _that.peerItem.peerid;
			let dev_ip = _that.peerItem.ip
				? _that.$common.ipConvert(_that.peerItem.ip)
				: "";
			_that.$router.push({
				name: "ImageBackup",
				params: {
					cur_pid: _that.peerid,
					dev_name: dev_name,
					dev_ip: dev_ip,
					dtype: _that.peerItem.dtype,
				},
			});
		},
		arrowXcbfClick: function () {
			let _that = this;
			_that.isShowXcbfUninstall = !_that.isShowXcbfUninstall;
			_that.isShowXbjfUninstall = false;
			_that.isShowKdtsUninstall = false;
			_that.isShowSpbfUninstall = false;
		},
		uninstallXcbfClick: function () {
			let _that = this;
			_that.xcbf = 9;
			_that.isShowXcbfUninstall = false;
			_that.miniappStatus([
				_that.peerid,
				"xcbf",
				0,
				function (err, data) {},
			]);

			_that.xcbfPercent = 5;
			setTimeout(function () {
				_that.xcbfPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.xcbfPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.xcbfPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.xcbf = -1;
			}, 2800);
		},

		installKdtsClick: function () {
			let _that = this;

			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}

			_that.kdts = 6;
			_that.kdtsPercent = 5;
			setTimeout(function () {
				_that.kdtsPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.kdtsPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.kdtsPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.kdts = 1;
			}, 2800);
			setTimeout(function () {
				_that.$router.push({
					name: "Kdts",
					params: { cur_pid: _that.peerid },
				});
			}, 3000);

			_that.miniappStatus([
				_that.peerid,
				"kdts",
				1,
				function (err, data) {},
			]);
		},
		openKdtsClick: function () {
			let _that = this;
			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}
			_that.$router.push({
				name: "Kdts",
				params: { cur_pid: _that.peerid },
			});
		},
		arrowKdtsClick: function () {
			let _that = this;
			_that.isShowKdtsUninstall = !_that.isShowKdtsUninstall;
			_that.isShowXbjfUninstall = false;
			_that.isShowXcbfUninstall = false;
			_that.isShowSpbfUninstall = false;
		},
		uninstallKdtsClick: function () {
			let _that = this;
			_that.kdts = 9;
			_that.isShowKdtsUninstall = false;
			_that.miniappStatus([
				_that.peerid,
				"kdts",
				0,
				function (err, data) {},
			]);

			_that.kdtsPercent = 5;
			setTimeout(function () {
				_that.kdtsPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.kdtsPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.kdtsPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.kdts = -1;
			}, 2800);
		},
		installXbjfClick: function () {
			let _that = this;

			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}
			_that.xbjf = 6;
			_that.xbjfPercent = 5;
			setTimeout(function () {
				_that.xbjfPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.xbjfPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.xbjfPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.xbjf = 1;
			}, 2800);

			setTimeout(function () {
				_that.$router.push({
					name: "SpeedShare",
					params: { cur_pid: _that.peerid },
				});
			}, 3000);

			_that.miniappStatus([
				_that.peerid,
				"xbjf",
				1,
				function (err, data) {
					// v2.3.1取消用户同意，直接同意
					// _that.miniappAgree([
					// 	_that.peerid,
					// 	"xbjf",
					// 	function (err, data) {},
					// ]);
				},
			]);
		},
		openYckjClick: function () {
			let _that = this;
			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}
			_that.$router.push({
				name: "Wakeup",
				params: { cur_pid: _that.peerid },
			});
		},
		openXbjfClick: function () {
			let _that = this;
			if (_that.peerItem.term.status == 1) {
				_that.tip = "设备已离线";

				setTimeout(function () {
					_that.tip = "";
				}, 1500);
				return;
			}
			_that.$router.push({
				name: "SpeedShare",
				params: { cur_pid: _that.peerid },
			});
		},
		arrowXbjfClick: function () {
			let _that = this;
			_that.isShowXbjfUninstall = !_that.isShowXbjfUninstall;
			_that.isShowKdtsUninstall = false;
			_that.isShowXcbfUninstall = false;
			_that.isShowSpbfUninstall = false;
		},
		uninstallXbjsClick: function () {
			let _that = this;
			_that.xbjf = 9;
			_that.isShowXbjfUninstall = false;
			_that.miniappStatus([
				_that.peerid,
				"xbjf",
				0,
				function (err, data) {},
			]);

			_that.xbjfPercent = 5;
			setTimeout(function () {
				_that.xbjfPercent = 15;
			}, 500);
			setTimeout(function () {
				_that.xbjfPercent = 90;
			}, 1500);
			setTimeout(function () {
				_that.xbjfPercent = 100;
			}, 2500);
			setTimeout(function () {
				_that.xbjf = -1;
			}, 2800);
		},

		activeClass: function (index) {
			let _that = this;
			let bgClass = "";
			if (_that.currentTab == index) {
				if (_that.currentTab == 0) {
					bgClass = "activeLeftBg";
				} else if (_that.currentTab == _that.list.length - 1) {
					bgClass = "activeRightBg";
				} else if (
					_that.currentTab > 0 &&
					_that.currentTab < _that.list.length - 1
				) {
					bgClass = "activeMiddleBg";
				}
			}
			return bgClass;
		},
		currentClickClass: function (index) {
			let _that = this;
			return _that.currentTab == index ? "activeWrap" : "";
		},
		arrowLeftClick: function () {
			let ele = document.getElementById("list");
			ele.scrollLeft = ele.scrollLeft - 90;
		},
		arrowRightClick: function () {
			let ele = document.getElementById("list");
			ele.scrollLeft = ele.scrollLeft + 90;
		},
		tabsClick: function (index, peerid, item) {
			let _that = this;
			_that.currentTab = index;
			_that.peerid = peerid;
			_that.peerItem = item;
			console.log("_that.peerItem", _that.peerItem);

			_that.getMiniappList(_that.peerid);
		},
		myBindget: function () {
			let _that = this;
			_that.bindget([
				function (err, data) {
					if (data && !data.rtn) {
						//rtn等于0时，后台不返回此字段
						if (data && !data.rtn) {
							//rtn等于0时，后台不返回此字段
							if (data && data.terms && data.terms.length > 0) {
								_that.isNoBind = false;
							} else {
								_that.isNoBind = true;
							}
						} else {
							_that.isNoBind = true;
						}

						if (data && data.terms && data.terms.length > 0) {
							_that.list = data.terms;

							for (
								let index = 0;
								index < _that.list.length;
								index++
							) {
								const element = _that.list[index];
								// for test
								// element.term.status = 1;
								// 构造ip mac 信息
								element.ip = "";
								element.mac = "";
								element.pidInfo = _that.$common.getInfoByPid(
									element.peerid
								);

								// if (element.term && !element.term.name) {
								let pidInfo = _that.$common.getInfoByPid(
									element.peerid
								);
								element.term.name = element.term.name
									? element.term.name
									: pidInfo.cname + pidInfo.dname;
								if (pidInfo.dname == "NAS") {
									element.dtype = 1;
								} else if (pidInfo.dname == "路由器") {
									element.dtype = 2;
								} else if (pidInfo.dname == "pc") {
									element.dtype = 3;
								}
								// }

								if (element.term && element.term.nic) {
									let nic = _that.$common.getNicByNics(
										element.term.nic
									);
									if (nic) {
										element.ip = nic.ipv4n;
										element.mac = nic.mac;
									}
								}
								if (element.term && element.term.comment) {
									if (element.term.comment == "0") {
										element.term.comment = "";
									}
								}
							}

							//默认显示第一个设备的远程服务列表
							let peerid = data.terms[0].peerid;
							let peerItem = data.terms[0];
							let peerIndex = 0;
							if (_that.cur_pid) {
								for (
									let index = 0;
									index < _that.list.length;
									index++
								) {
									const element = _that.list[index];
									if (_that.cur_pid == element.peerid) {
										peerid = element.peerid;
										peerItem = element;
										peerIndex = index;
										break;
									}
								}
							}
							// console.log("peerItem", peerItem);
							_that.peerid = peerid;
							_that.peerItem = peerItem;
							_that.currentTab = peerIndex;

							_that.getMiniappList(_that.peerid);
						}
					}
				},
			]);
		},
		getMiniappList: function (peerid) {
			let _that = this;
			_that.isLoading = true;
			_that.miniappList([
				peerid,
				function (err, data) {
					_that.isLoading = false;
					if (!err && data && data.rtn == 0) {
						if (!data.kdts) {
							_that.kdts = -1;
						} else {
							_that.kdts = data.kdts;
						}
						if (!data.xbjf) {
							_that.xbjf = -1;
						} else {
							_that.xbjf = data.xbjf;
						}
						if (!data.xcbf) {
							_that.xcbf = -1;
						} else {
							_that.xcbf = data.xcbf;
						}
						if (!data.spbf) {
							_that.spbf = -1;
						} else {
							_that.spbf = data.spbf;
						}
					}
				},
			]);
		},
	},
	computed: {},
	watch: {
		peerid: function (newval) {
			let _that = this;
			_that.pidInfo = _that.$common.getInfoByPid(_that.peerid);
			// 联想新设备不显示节点小宝
			if (_that.pidInfo.cid == 123) {
				_that.navItems = [2];
			} else {
				_that.navItems = [1, 2];
			}
			_that.$store.state.cur_pid = newval;

			//重置为未下拉
			_that.isShowKdtsUninstall = false;
			_that.isShowXbjfUninstall = false;
		},
	},
	activated() {
		let _that = this;
		_that.cur_pid = _that.$route.params.cur_pid
			? _that.$route.params.cur_pid
			: _that.$store.state.cur_pid;
		_that.myBindget();

		_that.isShowKdtsUninstall = false;
		_that.isShowXbjfUninstall = false;
		_that.isShowXcbfUninstall = false;
	},
	mounted() {},
};
</script>

<style lang="less" scoped>
.bg {
	background-position: center;
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
.applications {
	position: relative;
	height: 548px;
	padding-top: 1px;
	height: 100%;
	box-sizing: border-box;

	.loading-wrap {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		text-align: center;
		z-index: 9;
		background-color: rgba(255, 255, 255, 0.3);
		img {
			margin-top: 280px;
		}
	}

	.device-tabs {
		padding-right: 10px;
		padding-left: 10px;
		background-image: url("../assets/home/node/tabs_shadow_bg.png");
		background-repeat: no-repeat;
		background-size: 100% 7px;
		background-position: bottom;

		.list-wrap {
			position: relative;
			height: 84px;
			.list-wrap-hr {
				width: 100%;
				height: 1px;
				position: absolute;
				top: 5px;
				left: 0;
				background-color: #f5f5f5;
			}
			.arrow {
				display: inline-block;
				position: absolute;
				top: 6px;
				z-index: 3;
				width: 31px;
				height: 71px;
				background-color: rgba(251, 253, 255, 0.86);
				background-size: 10px 17px;
				background-position: center;
				background-repeat: no-repeat;
				cursor: pointer;
			}
			.arrow-left {
				background-image: url("../assets/home/node/arrow_left.svg");
				left: 0;
			}
			.arrow-right {
				background-image: url("../assets/home/node/arrow_right.svg");
				right: 94px;
				right: 188px;
				right: -10px;
			}
			.device-btn-group {
				position: absolute;
				right: 0;
				z-index: 3;
				top: 6px;

				.device-btn {
					height: 71px;
					width: 94px;
					background-color: #e8f5fe;
					box-sizing: border-box;
					text-align: center;
					display: inline-block;
					vertical-align: top;

					.device-btn-text {
						margin-top: 4px;
						color: #1f5de3;
						font-size: 12px;
					}
					.add-device-icon,
					.set-device-icon,
					.about-icon {
						margin-top: 15px;
						width: 20px;
						height: 20px;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						background-position: center;
						display: inline-block;
					}
					.add-device-icon {
						background-image: url("../assets/home/node/device_add.png");
					}
					.set-device-icon {
						background-image: url("../assets/home/node/device_setting.png");
					}
					.about-icon {
						background-image: url("../assets/home/node/about_icon.png");
					}
				}
				.device-btn:nth-child(2) {
					padding-left: 1px;
					background-image: url("../assets/home/node/tab_line.png");
					background-size: 1px 41px;
					background-repeat: no-repeat;
					background-position: left center;
				}
				.device-btn:hover {
					cursor: pointer;
					opacity: 0.9;
				}
			}

			.list {
				padding-top: 6px;
				// padding-right: 125px;
				// padding-right: 220px;
				width: 675px;
				width: 940px;
				padding-left: 31px;
				white-space: nowrap;
				overflow-x: hidden;
				overflow-y: hidden;
				height: 78px;
				background-image: url("../assets/home/node/tabs_shadow.png");
				background-repeat: no-repeat;
				background-size: 100% 7px;
				background-position: bottom;
				-ms-overflow-style: none;
				scrollbar-width: none;

				.item {
					position: relative;
					width: 189px;
					height: 71px;
					display: inline-block;
					background-color: #ebebeb;
					border-top-left-radius: 2px;
					box-sizing: border-box;
					cursor: pointer;

					.device-bind-wrap {
						width: 100%;
						height: 100%;
						.device-status-wrap {
							display: inline-block;
							vertical-align: top;
							margin-top: 10px;
							.device-icon {
								position: relative;
								z-index: 2;
								width: 48px;
								height: 48px;
								margin-left: 10px;
								background-image: url("../assets/common/nas-icon-online.png");
								background-repeat: no-repeat;
								background-size: 100% 100%;

								.device-status {
									position: absolute;
									bottom: -5px;
									left: 50%;
									transform: translate(-50%, 0);
									width: 31px;
									height: 14px;
									line-height: 14px;
									text-align: center;
									background-color: #1f5de3;
									border-radius: 41px;

									div {
										font-size: 12px;
										color: #f0f0f0;
										transform: scale(0.75);
									}
								}
								.device-status-off {
									background-color: #999999;
								}
							}
							.device-icon.device-icon-pc {
								background-image: url("../assets/common/pc-icon-online.png");
							}
							.device-icon.device-icon-router {
								background-image: url("../assets/common/router-icon-online.png");
							}
							.device-icon-off {
								background-image: url("../assets/common/nas-icon-offline.png");
							}
							.device-icon.device-icon-pc.device-icon-off {
								background-image: url("../assets/common/pc-icon-offline.png");
							}
							.device-icon.device-icon-router.device-icon-off {
								background-image: url("../assets/common/router-icon-offline.png");
							}
						}

						.device-name-wrap {
							position: relative;
							z-index: 2;
							margin-left: 8px;
							display: inline-block;
							vertical-align: top;
							margin-top: 18px;
							.device-name {
								color: #1c1f28;
								font-size: 14px;
								width: 120px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								font-weight: bolder;
							}
							.device-ip {
								color: #999999;
								font-size: 12px;
								transform: scale(0.8);
								transform-origin: left center;
							}
						}
					}
				}

				.item:nth-child(n + 2) {
					padding-left: 1px;
					background-image: url("../assets/home/node/tab_line.png");
					background-size: 1px 52px;
					background-repeat: no-repeat;
					background-position: left center;
				}

				.item:hover {
					background-color: #f0f3f8;
				}

				.activeWrap {
					position: relative;

					.activeLeftBg {
						position: absolute;
						top: -18px;
						z-index: 1;
						left: -12px;
						width: 225px;
						height: 105px;
						// background-image: url("../assets/home/node/tab_bg1.png");
						// background-image: url("../assets/speedShare/tab_bg.png");
						background-repeat: no-repeat;
						background-size: 100% 100%;
						background-position: center;
						overflow: hidden;
						.bgBlack {
							margin-left: 13px;
							box-shadow: 2px 0px 6px 0px rgba(193, 193, 193, 0.9);
						}
					}
					.activeRightBg {
						position: absolute;
						top: -18px;
						z-index: 1;
						left: -23px;
						width: 224px;
						height: 105px;
						// background-image: url("../assets/home/node/tab_bg2.png");
						// background-image: url("../assets/speedShare/tab_bg.png");
						background-repeat: no-repeat;
						background-size: 100% 100%;
						background-position: center;
						overflow: hidden;
						.bgBlack {
							margin-left: 23px;
						}
					}
					.activeMiddleBg {
						position: absolute;
						top: -18px;
						z-index: 1;
						left: -24px;
						width: 237px;
						height: 105px;
						// background-image: url("../assets/home/node/tab_bg3.png");
						// background-image: url("../assets/speedShare/tab_bg.png");
						background-repeat: no-repeat;
						background-size: 100% 100%;
						background-position: center;
						overflow: hidden;
						.bgBlack {
							margin-left: 24px;
						}
					}
					.bgBlack {
						margin-top: 15px;
						width: 190px;
						height: 74px;
						background-color: #ffffff;
						box-shadow: 0px 0px 8px 0px rgba(193, 193, 193, 0.9);
						border-top-left-radius: 3px;
						border-top-right-radius: 3px;
					}
				}
			}
			.list::-webkit-scrollbar {
				display: none;
			}
			.nopadding {
				padding-left: 0;
			}
		}
	}

	.wrap {
		margin: 0 auto;
		padding-top: 14px;
		width: 940px;
		height: 415px;
		overflow-y: scroll;
		background-image: url("../assets/applications/a1.png");
		border-radius: 3px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		.bg();
		box-sizing: border-box;
		.icon-wrap {
			position: relative;
			margin: 0 auto;
			width: 898px;
			height: 115px;
			border-radius: 3px;
			overflow: hidden;
			box-sizing: border-box;

			// .el-carousel__item:nth-child(2n) {
			// 	background-image: url("../assets/applications/a3.png");
			// 	.bg();
			// }

			// .el-carousel__item:nth-child(2n + 1) {
			// 	background-image: url("../assets/applications/a2.png");
			// 	.bg();
			// }

			.item_wrap_1 {
				height: 100%;
				padding-top: 1px;
				background-image: url("../assets/applications/a3.png");
				.bg();
			}

			.item_wrap_2 {
				height: 100%;
				padding-top: 1px;
				background-image: url("../assets/applications/a2.png");
				.bg();
			}

			.text1 {
				margin-top: 28px;
				margin-left: 126px;
				line-height: 32px;
				font-size: 27px;
				font-weight: 700;
				color: #1411a8;
			}
			.text2 {
				margin-top: 10px;
				margin-left: 126px;
				line-height: 14px;
				font-size: 12px;
				color: #4341a9;
			}
		}
		.app-wrap {
			position: relative;
			padding-top: 20px;
			padding-bottom: 20px;
			margin: 0 auto;
			width: 782px;
			box-sizing: border-box;
			.text1 {
				margin-left: 61px;
				font-size: 15px;
				font-weight: 700;
				color: #1a1a1a;
				line-height: 18px;
			}
			.text2 {
				margin-left: 61px;
				margin-top: 7px;
				font-size: 12px;
				color: #666666;
				line-height: 14px;
			}
			.btn {
				position: absolute;
				right: 0;
				top: 50%;
				transform: translate(0, -50%);
				width: 99px;
				height: 31px;
				line-height: 31px;
				font-size: 12px;
				color: #153f9a;
				text-align: center;
				background-color: #dce7ff;
				border-radius: 20px;
				font-weight: 700;
				cursor: pointer;
			}

			.btn2 {
				position: absolute;
				right: 0;
				top: 50%;
				transform: translate(0, -50%);
				width: 99px;
				height: 31px;
				line-height: 31px;
				font-size: 12px;
				color: #153f9a;
				text-align: center;
				font-weight: 700;
				cursor: pointer;

				.text {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					z-index: 9;
					white-space: nowrap;
				}
			}
			.btn3 {
				position: absolute;
				right: 110px;
				top: 50%;
				transform: translate(0, -50%);
				width: 99px;
				height: 31px;
				line-height: 31px;
				font-size: 12px;
				color: #ffffff;
				text-align: center;
				background-color: #1f5de3;
				border-radius: 20px;
				font-weight: 700;
				cursor: pointer;

				.icon {
					position: absolute;
					right: 10px;
					top: -2px;
					width: 24px;
					height: 32px;
					background-image: url("../assets/applications/a4.svg");
					.bg();
					background-size: 17px 17px;
				}
				.icon2 {
					top: -1px;
					background-image: url("../assets/applications/a5.svg");
				}
			}
			.btn-open {
				right: 0;
			}
			.btn-stop {
				background-color: #dce7ff;
				color: #153f9a;
			}
			.uninstall-btn {
				position: absolute;
				right: 110px;
				bottom: -6px;
				width: 99px;
				height: 31px;
				line-height: 31px;
				font-size: 12px;
				color: #7b88a7;
				text-align: center;
				background-color: #d9deea;
				border-radius: 20px;
				font-weight: 700;
				cursor: pointer;
			}
			.offline-btn {
				background-color: #7c88a1;
				color: #ffffff;
			}
		}
		.app-wrap1 {
			border-bottom: 1px solid #e9e9e9;
		}
		.app-wrap3 {
			border-bottom: 1px solid #e9e9e9;
		}
		.app-wrap5 {
			border-bottom: 1px solid #e9e9e9;
		}
		.app-wrap2 {
			border-bottom: 1px solid #e9e9e9;
		}
		.app-wrap1::before,
		.app-wrap2::before,
		.app-wrap3::before,
		.app-wrap5::before,
		.app-wrap4::before {
			position: absolute;
			left: 0;
			top: 50%;
			transform: translate(0, -50%);
			content: "";
			width: 48px;
			height: 48px;
			background-image: url("../assets/tool/byjs-icon.png");
			.bg();
		}
		.app-wrap2::before {
			background-image: url("../assets/tool/kdts-icon.png");
		}
		.app-wrap3::before {
			background-image: url("../assets/tool/xcbf-icon.png");
		}
		.app-wrap5::before {
			background-image: url("../assets/tool/spbf-icon.png");
		}
		.app-wrap4::before {
			background-image: url("../assets/tool/yckj-icon.png");
		}
	}
}
</style>
<style lang="less">
.el-carousel__indicator {
	.el-carousel__button {
		background-color: #7c88a1;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		opacity: 1;
	}
}
.is-active {
	.el-carousel__button {
		background-color: #1f5de3;
	}
}
.el-progress-bar {
	.el-progress-bar__outer {
		background-color: #dce7ff;
		border: 1px solid #449ff3;
		box-sizing: border-box;

		.el-progress-bar__inner {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;

			.el-progress-bar__innerText {
				color: transparent;
			}
		}
	}
}
</style>
